import * as React from 'react';
import { SVGProps } from 'react';

const SvgRefresh = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      d="M8 14c-1.675 0-3.094-.581-4.256-1.744C2.58 11.094 2 9.675 2 8c0-1.675.581-3.094 1.744-4.256C4.906 2.58 6.325 2 8 2c.863 0 1.688.178 2.475.535A5.713 5.713 0 0 1 12.5 4.062V2H14v5.25H8.75v-1.5h3.15c-.4-.7-.947-1.25-1.64-1.65-.694-.4-1.447-.6-2.26-.6-1.25 0-2.313.438-3.188 1.313S3.5 6.75 3.5 8c0 1.25.438 2.313 1.313 3.188C5.688 12.062 6.75 12.5 8 12.5c.963 0 1.831-.275 2.606-.825A4.357 4.357 0 0 0 12.238 9.5h1.575a5.922 5.922 0 0 1-2.138 3.244A5.82 5.82 0 0 1 8 14Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgRefresh;
